import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const FeaturedDiscussion = ({ discussion, onClick }) => {
  return (
    <div 
      onClick={() => onClick(discussion)}
      className="bg-card border border-border rounded-lg p-4 hover:shadow-wellness transition-wellness cursor-pointer"
    >
      <div className="flex items-start space-x-3">
        <Image
          src={discussion?.author?.avatar}
          alt={discussion?.author?.name}
          className="w-10 h-10 rounded-full object-cover"
        />
        
        <div className="flex-1 min-w-0">
          <div className="flex items-center space-x-2 mb-2">
            <h4 className="font-medium text-foreground text-sm truncate">
              {discussion?.title}
            </h4>
            {discussion?.isExpertResponse && (
              <div className="flex items-center space-x-1 bg-accent/10 px-2 py-1 rounded-full">
                <Icon name="Award" size={12} className="text-accent" />
                <span className="text-xs font-caption text-accent-foreground">Expert</span>
              </div>
            )}
          </div>
          
          <p className="text-muted-foreground text-xs mb-2 line-clamp-2">
            {discussion?.preview}
          </p>
          
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3 text-xs text-muted-foreground">
              <span>{discussion?.author?.name}</span>
              <span>•</span>
              <span>{discussion?.timeAgo}</span>
            </div>
            
            <div className="flex items-center space-x-2 text-xs text-muted-foreground">
              <div className="flex items-center space-x-1">
                <Icon name="Heart" size={12} />
                <span>{discussion?.likes}</span>
              </div>
              <div className="flex items-center space-x-1">
                <Icon name="MessageCircle" size={12} />
                <span>{discussion?.replies}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeaturedDiscussion;